import { render, staticRenderFns } from "./communication-transcription-button.vue?vue&type=template&id=fddd586e"
import script from "./communication-transcription-button.vue?vue&type=script&lang=js"
export * from "./communication-transcription-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports